import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import GameIntro from '../gameIntro/GameIntro';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal({show, setShowModal, setGameMode, removeCookie}){
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setShowModal(false);
    setOpen(false);
};

  return (
    <div>
        <Modal  open={show} onClose={handleClose}>
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                Batting Cage Intro
                </Typography>
                <GameIntro setGameMode={setGameMode} removeCookie={removeCookie} handleClose={handleClose}/>
            </Box>
        </Modal>

    </div>
  );
}